import styled, { css } from 'styled-components';
import { COLORS } from 'modules/core/theme/colors';
import { lockedCheckboxMixin, lockedCheckedCheckboxMixin } from 'modules/core/theme/mixins';

export const CheckBox = styled.div<{
  hasError: boolean;
  isVerify?: boolean;
  checkedColor?: string;
  labelColor?: string;
  $locked?: boolean;
}>`
  ${({ hasError }) =>
    hasError &&
    `
    .form-check-input {
      border-color: ${COLORS.RED_6};
    }
    .form-check-label {
      color: ${COLORS.RED_6};
    }
  `}

  line-height: 16px;

  .form-check-input:checked {
    background-color: ${({ checkedColor }) => checkedColor || COLORS.GREY_24};
    border-color: ${({ checkedColor }) => checkedColor || COLORS.GREY_24};
    color: black;
  }
  ${({ checkedColor, labelColor }) =>
    checkedColor &&
    `
    .form-check-label {
      color: ${labelColor || checkedColor};
    }

    .form-check-input {
      accent-color: ${checkedColor};
      border-color: ${checkedColor};
    }
  `}

  ${({ $locked }) =>
    $locked &&
    css`
      color: ${COLORS.GREY_35};

      .form-check-label {
        color: ${COLORS.GREY_35};
      }

      .form-check-input:disabled {
        ${lockedCheckboxMixin}
      }

      .form-check-input:checked:disabled {
        ${lockedCheckedCheckboxMixin}
      }

      .form-check-input:disabled ~ .form-check-label {
        cursor: not-allowed;
        color: ${COLORS.GREY_35};
        opacity: 1;
      }
    `}
  .form-check-input:active {
    outline: none;
  }
  .form-check-input:focus {
    outline: none;
    box-shadow: none;
    border-color: 1px solid ${({ checkedColor }) => checkedColor || COLORS.GREY_24};
  }
  .form-check-input,
  .form-check-label {
    font-size: 12px;
  }

  margin: ${({ isVerify }) => isVerify && '12px 0'};

  ${({ isVerify }) =>
    isVerify &&
    `
      label {
        font-size: 12px;
        line-height: 12px;
      }
  `}
`;

export const Input = styled.input<{ isVerify?: boolean; $locked?: boolean }>`
  margin-right: 4px;
  margin-top: ${({ isVerify }) => (isVerify ? '4px' : '2px')};
  width: ${({ isVerify }) => isVerify && '12px'};
  height: ${({ isVerify }) => isVerify && '12px'};
  /* Set here rather than leaning on the locked block outspecifying this rule. */
  cursor: ${({ $locked }) => ($locked ? 'not-allowed' : 'pointer')};
`;

export const Label = styled.label<{ $locked?: boolean }>`
  display: contents;
  cursor: ${({ $locked }) => ($locked ? 'not-allowed' : 'pointer')};
`;
